import { Component, ReactNode } from 'react'

export interface ErrorBoundaryProps {
  children: ReactNode
  fallback: (({ error, reset }: { error: any; reset: () => void }) => ReactNode) | ReactNode
}

export type ErrorBoundaryState =
  | {
      error: any
      hasError: true
    }
  | {
      hasError: false
    }

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: any): ErrorBoundaryState {
    return {
      error,
      hasError: true,
    }
  }

  reset() {
    this.setState({ hasError: false })
  }

  override render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    if (typeof this.props.fallback === 'function') {
      return this.props.fallback({ error: this.state.error, reset: this.reset.bind(this) })
    }

    return this.props.fallback
  }
}
